<ngx-loading-bar [color]="'#9E1E22'"></ngx-loading-bar>
<!-- <h1>{{ env.apiUrl }}</h1>
<h1>{{ env.production }}</h1> -->
<router-outlet></router-outlet>
